import { Controller } from "@hotwired/stimulus"

// Toggles a campaign form between its "scheduled" and "journey" field sets based
// on the selected kind radio. Scheduled campaigns show a start date + audience
// picker; journey campaigns show a trigger picker (the audience is forced to
// Active Members server-side). Fields in the inactive section are disabled so
// they don't submit — e.g. a leftover trigger_id won't attach to a scheduled
// campaign, and the nested campaign_trigger's reject_if (trigger_id blank) then
// drops it cleanly. (#218 phase 2)
//
// Targets:
//   scheduledFields - sections shown only for kind=scheduled
//   journeyFields   - sections shown only for kind=journey
export default class extends Controller {
  static targets = ["scheduledFields", "journeyFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const kind = this.selectedKind
    this.setSection(this.scheduledFieldsTargets, kind === "scheduled")
    this.setSection(this.journeyFieldsTargets, kind === "journey")
  }

  setSection(sections, active) {
    sections.forEach((section) => {
      section.hidden = !active
      section.querySelectorAll("input, select, textarea").forEach((field) => {
        field.disabled = !active
      })
    })
  }

  get selectedKind() {
    const checked = this.element.querySelector('input[name="campaign[kind]"]:checked')
    return checked ? checked.value : "scheduled"
  }
}
